module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/vip5-9fa9ae20092c7c0b3aacc6d6b5b84f38.png";